import LocalStorageUtils from 'utils/LocalStorage'
import axios from 'axios'
import Constant from 'utils/Constants'
import i18n from 'i18n';
import LunaAlert from 'utils/LunaAlert';
import { toast } from 'react-hot-toast';
import RollbarConfig from "utils/RollbarConfig";

export const AXIOS_ABORT_CONTROLLER = new AbortController();

const apiReport = axios.create({
    baseURL: Constant.baseApiReportURL,
    timeout: Constant.apiTimeout,
    timeoutErrorMessage: 'Waktu habis, sudah melewati batas maksimum proses konseksi ke server',
    withCredentials: true,
    signal: AXIOS_ABORT_CONTROLLER.signal,
    headers: {
        Accept: 'application/json',
        "Access-Control-Allow-Origin": "*",
        ContentType: 'application/json'
    }
})

apiReport.interceptors.request.use(
    (config) => {
        const tokenBeforeRequest = LocalStorageUtils.jwtToken.get()

        config.headers['Authorization'] = `Bearer ${tokenBeforeRequest}`
        config.headers['Accept'] = `application/json`
        config.headers['ContentType'] = `application/json`

        if(!tokenBeforeRequest) {

            const {t} = i18n

            RollbarConfig.error(`User try to hit api while no token in the client browser`, {
                'device': navigator?.userAgentData
            })

            LunaAlert.error({
                title: t('globalAlert.notAuthenticated'),
                description: t('globalAlert.notAuthenticatedMessage'),
                confirmButtonText: t('common.gotoLogin'),
                swalOptions: {
                    allowEnterKey: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false
                },
                onConfirmButton: () => {
                    window.location.replace('/')
                }
            })

            return false;
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

apiReport.interceptors.response.use(function (response) {
    return response
}, async function (error) {
    if ((error?.response?.status === 401 || error?.response?.data?.message.toLowerCase() === 'unauthorized') && LocalStorageUtils.loginCheckToken.get().length === 0) {
        const {t} = i18n
        
        RollbarConfig.error(`Unauthorized when sending api /mst/user-login/check-token. Token:${LocalStorageUtils.jwtToken.get()}`, {
            'user_token': LocalStorageUtils.jwtToken.get(),
            'server_response': error?.response
        })

        AXIOS_ABORT_CONTROLLER.abort()

        toast.dismiss()
        await LunaAlert.error({
            title: t('globalAlert.notAuthenticated'),
            description: t('globalAlert.notAuthenticatedMessage'),
            confirmButtonText: t('common.gotoLogin'),
            swalOptions: {
                allowEnterKey: false,
                allowEscapeKey: false,
                allowOutsideClick: false
            },
            onConfirmButton: () => {
                window.location.replace('/')
            }
        })

        window.location.replace('/')
        return false;
    } 

    return Promise.reject(error)
})


export default apiReport
